module.exports = __webpack_public_path__ + "img/Twist44.c8675906.jpg";